import { render, staticRenderFns } from "./FlowDetailBlock.vue?vue&type=template&id=069504c5&scoped=true&"
import script from "./FlowDetailBlock.vue?vue&type=script&lang=js&"
export * from "./FlowDetailBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069504c5",
  null
  
)

export default component.exports